import { render, staticRenderFns } from "./guji-left-nav.vue?vue&type=template&id=2b59eee5&scoped=true&"
import script from "./guji-left-nav.vue?vue&type=script&lang=ts&"
export * from "./guji-left-nav.vue?vue&type=script&lang=ts&"
import style0 from "./guji-left-nav.vue?vue&type=style&index=0&id=2b59eee5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59eee5",
  null
  
)

export default component.exports